export default {
  title: 'Diseño de pedido',
  form: {
    show_hero_image_with_offers: {
      label: 'Mostrar imagen destacada con ofertas',
      description: 'Por defecto, agregar una imagen de oferta oculta la imagen destacada. Actívelo para mostrar ambas.',
    },
  },
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    failed_to_save_changes: 'Error al guardar los cambios',
    changes_got_saved: 'Cambios guardados',
  },
};
